/* eslint-disable react-hooks/exhaustive-deps */
import axios from 'axios'
import { useEffect, useState, useRef } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { RotatingLines } from "react-loader-spinner"
import Travelpayouts from './affiliazioni/travelpayouts'
import 'swiper/css'

function Alberghi({ flag, flag2, flag3, distanza, lat, lng, idEvento, onChangeOpacity, onChiudi, dettagliIsOpen }) {
    const [alberghi, setAlberghi] = useState([])//trovati in google API places(new)
    const [albergo, setAlbergo] = useState(null)
    const [msg, setMsg] = useState({ ristoNotFound: null })
    const [fillPercentage, setFillPercentage] = useState()// rating rist da google Places
    const [currentIndex, setCurrentIndex] = useState(0)

    const dettagliRef = useRef()

    const containerStyle = {
        width: '95%',
        height: '20px',
        backgroundColor: '#e0e0e0', // Grigio chiaro per la parte vuota
        borderRadius: '10px',
        overflow: 'hidden',
        border: '1px solid #ccc',
        margin: '1em auto'
    }
    const fillStyle = {
        height: '100%',
        width: `${fillPercentage}%`, // Larghezza dinamica
        backgroundColor: '#fdc408', // Verde per la parte piena
        transition: 'width 0.5s ease-in-out', // Animazione fluida
    }
    async function getAlberghi() {
        try {
            const res = await axios.get(`/alberghi/${lat}/${lng}`)//places oggetto e routingSummaries alro oggetto
            if (Object.keys(res.data.hotelByGooglePlaces).length !== 0) {
                document.getElementById('rotary').style.display = 'none'
                const nuovoArray = res.data.hotelByGooglePlaces.places.map((item, index) => ({//places e routingSummaries in unico oggetto
                    ...item,
                    ...res.data.hotelByGooglePlaces.routingSummaries[index]
                }))
                setAlberghi(nuovoArray)
            } else {
                setMsg({ ristoNotFound: '*** Nessun hotel trovato ***' })
                document.getElementById('rotary').style.display = 'none'
            }
        } catch (err) { console.log(err) }
    }
    function dettagli(e) {
        dettagliIsOpen('secondoAlberghi')
        const rist = alberghi.filter((item, index) => index === e)[0]
        setAlbergo(rist)
        // Assicuriamo che il rating sia tra 0 e 5
        const safeRating = (Math.min(Math.max(rist.rating, 0), 5))
        // Calcolo della percentuale di riempimento (es: 3.5 -> 70%)
        setFillPercentage((safeRating / 5) * 100)
    }
    const prevSlide = () => {
        setCurrentIndex((prevIndex) => prevIndex === 0 ? albergo.photos.length - 1 : prevIndex - 1)
    }
    const nextSlide = () => {
        setCurrentIndex((prevIndex) => prevIndex === albergo.photos.length - 1 ? 0 : prevIndex + 1)
    }
    useEffect(() => {
        if (flag === 'primoAlberghi' && alberghi.length === 0 && lat) {
            setMsg({ ristoNotFound: null }); getAlberghi(); document.getElementById('rotary').style.display = 'block'
        }
    }, [lat, flag])

    // useEffect(() => { console.log(alberghi.length) }, [alberghi])
    return (<>
        <div className={`divNotifiche${flag === 'primoAlberghi' || flag2 === 'secondoAlberghi' || flag3 === 'terzoAlberghi' ? 'Aperto' : ''}`}
            style={{ marginTop: '-4em', height: '100%', padding: '3px' }}>

            <button style={{ fontSize: 'xx-large', border: 'none' }}
                onClick={onChiudi}>◀
            </button>

            <p className='mt-1 text-center' id="rotary">
                <RotatingLines strokeColor='silver' strokeWidth='5' animationDuration='5' width='26' />
            </p>

            <div style={{ margin: '0 3px', overflowY: 'scroll', height: '90%' }}>
                <p className='text-center fs-5'><i>{msg.ristoNotFound}</i></p>
                {alberghi.length !== 0 && //da google
                    alberghi.map((albergo, index) => (
                        <div style={{ borderBottom: '1px solid lightgrey', display: 'grid', gridTemplateColumns: '1fr', gap: '5px', cursor: 'pointer', margin: '8px 0' }}
                            onClick={() => { dettagli(index) }} key={index}>
                            <p><span style={{ backgroundColor: 'gainsboro', borderRadius: '7px', padding: '3px', fontWeight: '600' }}>{albergo.displayName.text}</span> <i style={{ opacity: '.6' }}>{albergo.formattedAddress}</i></p>
                        </div>
                    ))}
            </div>
        </div>

        {/* ------------------------ BANNER DETTAGLI HOTEL DA GOOGLE --------------------------- */}
        <div className={`divNotifiche${flag2 === 'secondoAlberghi' || flag3 === 'terzoAlberghi' ? 'Aperto' : ''}`} style={{ marginTop: '-4em', height: '100%', padding: '3px' }}
            ref={dettagliRef}>
            <button style={{ fontSize: 'xx-large', border: 'none' }}
                onClick={onChiudi}>◀
            </button><hr />
            {albergo &&
                <div style={{ textAlign: 'center', overflowY: 'scroll', height: '90%' }}>
                    {/* ---------------- IMMAGINE ---------------------- */}
                    <div style={{ overflow: 'auto', whiteSpace: 'nowrap', overflowY: 'hidden' }}>
                        {albergo.photos &&
                            albergo.photos.map((photo, index) => (
                                <div className="scrollmenu_risto" key={index + 'google'}>
                                    <img src={`https://places.googleapis.com/v1/${photo.name}/media?key=${process.env.REACT_APP_GOOGLE_MAPS}&maxWidthPx=250&maxHeightPx=250`}
                                        style={{ width: '22em', height: '18em', objectFit: 'cover' }} role="button" onClick={() => {
                                            dettagliIsOpen('terzoAlberghi'); setCurrentIndex(index)
                                        }} alt='' />
                                </div>
                            ))}
                    </div>

                    {/* ----------------- NOME E INDIRIZZO ---------------  */}
                    <div className='mt-5'>
                        <div style={{ textAlign: 'left', fontSize: 'x-large', margin: '0 10px', fontFamily: 'serif' }}>
                            <p>{albergo.displayName.text}</p>
                            <p style={{ fontSize: 'large', opacity: '.8' }}>{albergo.formattedAddress}</p>

                            <p className='fs-6'>
                                <img src={require('../image/icons8-telefono-cellulare-48.png')} width={'30px'} alt='' /> {albergo.nationalPhoneNumber}
                            </p><hr />
                            <p className='fs-5'>
                                <img src={require('../image/icons8-visita-24.png')} alt='' /> {(albergo.legs[0].distanceMeters / 1000).toFixed(1)} km
                            </p>
                            <Travelpayouts restaurantName={albergo.displayName.text} address={albergo.formattedAddress} />
                        </div><hr />
                        {/* ------------------ VALUTAZIONE ------------------- */}
                        <p>Valutazione: {albergo.rating}</p>
                        <div style={containerStyle}>
                            <div style={fillStyle}></div>
                        </div>  <br /><br />
                    </div>
                </div>
            }
        </div>

        {/* ------------------- DIV PER VISUALIZZARE SLIDER-SHOW HOTEL DA GOOGLE ----------------- */}
        {flag3 === 'terzoAlberghi' &&
            <div>
                {/* ------------------- DESKTOP ----------------- */}
                <div style={{ position: 'fixed', top: '0', left: '0', width: '100%', height: '100%', backgroundColor: 'whitesmoke', zIndex: '9999' }}>
                    <div className='addImg2' style={{
                        position: 'fixed', top: '22em', left: '50%', transform: 'translate(-50%, -50%)', border: '1px solid grey',
                        width: '600px', height: '450px', borderRadius: '8px', justifyContent: 'center', alignItems: 'center'
                    }}>
                        {albergo && <p style={{ position: 'absolute', top: '-2em', fontSize: 'x-large' }}>{albergo.displayName.text}</p>}
                        <img src={require('../image/icons8-chiudi-macos-32.png')} style={{
                            position: 'absolute', top: '-2.5em', left: '95%', cursor: 'pointer', width: '40px',
                        }} onClick={onChiudi} alt='' />
                        <button className='left-arrow' onClick={prevSlide}>◀</button>
                        {albergo &&
                            <img id="imgRistoDesktop"
                                src={`https://places.googleapis.com/v1/${albergo.photos[currentIndex].name}/media?key=${process.env.REACT_APP_GOOGLE_MAPS}&maxWidthPx=550&maxHeightPx=478`}
                                style={{ width: '600px', height: '450px', borderRadius: '10px', objectFit: 'cover' }} alt='' />
                        }
                        <button className='right-arrow' onClick={nextSlide}>▶</button>
                        {albergo &&
                            <p className='mt-1' style={{ position: 'absolute', top: '100%', textAlign: 'center', opacity: '.7' }}>
                                {albergo.photos[currentIndex].authorAttributions[0].displayName}
                            </p>
                        }
                        <button className='btn btn-secondary mt-5' style={{ position: 'absolute', top: '100%', left: '0' }} onClick={onChiudi}>indietro</button>
                    </div>
                </div>

                {/* ------------------- MOBILE ----------------- */}
                <div className='iconChatMobile' style={{ position: 'fixed', top: '0', left: '0', width: '100%', height: '100%', backgroundColor: 'whitesmoke', zIndex: '9999' }}>
                    <div style={{
                        position: 'fixed', top: '19em', width: '98%', height: '340px', borderRadius: '8px',
                        left: '50%', transform: 'translate(-50%, -50%)', justifyContent: 'center', alignItems: 'center'
                    }}>
                        {albergo && <p style={{ position: 'absolute', top: '-1.5em', fontSize: 'large', marginLeft: '2em' }}>{albergo.displayName.text}</p>}
                        <img src={require('../image/icons8-chiudi-macos-32.png')} style={{ position: 'absolute', top: '-2.5em', left: '90%', cursor: 'pointer', width: '40px' }}
                            onClick={onChiudi} alt='' />
                        <Swiper spaceBetween={10} slidesPerView={1} navigation pagination={{ clickable: true }} className='mt-4'>
                            {albergo &&
                                albergo.photos.map((photo, index) => (
                                    <SwiperSlide key={index + 'mobile'}>
                                        <img src={`https://places.googleapis.com/v1/${photo.name}/media?key=${process.env.REACT_APP_GOOGLE_MAPS}&maxWidthPx=300&maxHeightPx=300`}
                                            style={{ width: '100%', height: '300px', borderRadius: '10px', objectFit: 'cover' }} alt='' />
                                        <p style={{ marginTop: '1em', textAlign: 'center', opacity: '.7' }}>
                                            {photo.authorAttributions[0].displayName}
                                        </p>
                                    </SwiperSlide>
                                ))
                            }
                        </Swiper>
                        <button className='btn btn-secondary' onClick={onChiudi}>Indietro</button>
                    </div>
                </div>
            </div>
        }
    </>)
}
export default Alberghi